import api from "@/plugins/api";
const BASE_PATH = "/opink-merge-fields";
/**
 * API client for the merge-field catalogue (US-1.17). Goes through the BFF
 * (`/opink-merge-fields`); the response envelope is unwrapped by the api plugin into `.data`.
 */
export const mergeFieldsApi = {
    async list() {
        const response = await api.get(BASE_PATH, { unwrapEnvelope: true });
        return response.data;
    },
};
